const $ = window.jQuery;
const $window = window.$window || $(window);
const $document = window.$document || $(document);

const EddCartMods = {

    init() {

        // todo - clean this up. This is all copied in from the footer file and probably only needs to run on the
        //  checkout page. Evaluate what we need here, see if some of this can't be done in PHP instead, then clean this
        //  up. If it only needs to run on the checkout page, let's through in a condition to make that happen.

        // $('.edd_cart_tax').html(function (idx, oldHtml) {
        //     return oldHtml.replace(/Tax/, "GST");
        // });

        // $('.edd-table').html(function (idx, oldHtml) {
        //     return oldHtml.replace(/Tax/, "GST");
        // });

        // $('#edd_checkout_cart td').each(function (index) {
        //     $(this).html(function (idx, oldHtml) {
        //         return oldHtml.replace(/AUD/, "<small>AUD</small>");
        //     });
        // });

        // $('#edd_checkout_cart th').each(function (index) {
        //     $(this).html(function (idx, oldHtml) {
        //         return oldHtml.replace(/AUD/, "<small>AUD</small>");
        //     });
        // });

        // $('.edd-table td').each(function (index) {
        //     $(this).html(function (idx, oldHtml) {
        //         return oldHtml.replace(/AUD/, "<small>AUD</small>");
        //     });
        // });


        $('.faq-block').each(function () {
            let $this = $(this);
            let $title = $this.find('.faq-block__header');
            let $content = $this.find('.faq-block__content');
            $content.slideUp(0);
            $this.addClass('faq-block--closed');
            $title.click(function () {
                $content.slideToggle(160);
                $this.toggleClass('faq-block--closed faq-block--open');
            });
        });

        $('.edd_cart_tax .edd_cart_tax_amount').each(function (index) {
            let gst = $(this).data("tax");
            if (gst > 0) {
                $('.edd_cart_tax').show();
            } else {
                $('.edd_cart_tax').hide();
            }
        });

        $(document).ajaxComplete(function () {

            $('.edd_cart_tax .edd_cart_tax_amount').each(function (index) {
                let gst = $(this).data("tax");
                if (gst > 0) {
                    $('.edd_cart_tax').show();
                } else {
                    $('.edd_cart_tax').hide();
                }
            });
            //
            // $('#edd_checkout_cart .edd_cart_amount').each(function (index) {
            //     let total = $(this).data("total").toFixed(0);
            //     let subtotal = $(this).data("subtotal").toFixed(0);
            //     let savings = (Number(subtotal) - Number(total)).toFixed(0);
            //     let message = '$' + total + '<small> AUD </small> <br><small>(Was $' + subtotal + ', you\'ve saved $' + savings + ' AUD)</small>';
            //
            //     if (savings > 11) {
            //         $('#edd_final_total_wrap .edd_cart_amount').html(message);
            //         $(this).html(message);
            //     } else {
            //         $('#edd_final_total_wrap .edd_cart_amount').html('$' + total + '<small> AUD</small>');
            //         $(this).html('$' + total + '<small> AUD</small>');
            //     }
            // });

            //$('.edd_discount_rate').html('<small>Cyber Monday &amp; Black Friday Sale:</small> Save 33%')

        });


    }

};

export default EddCartMods;